/* eslint-disable */
import React, { useState, useEffect } from "react";
import * as API from "../../framework/API/api";
import { ENTITYNAME, FILEURL, TOAST_TYPES } from "../../framework/constant/constant";
import ActionButton from "../../framework/forms/helpercomponents/buttons/ActionButton";
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import { utility } from "../../framework/utility/utilityProvider";
import { useTranslation } from "../../locale/useTranslation";
import { Grid, GridColumn as Column, GridNoRecords } from "@progress/kendo-react-grid";
import { RadioButton } from "@progress/kendo-react-inputs";
import RoundButton from "../../framework/forms/helpercomponents/buttons/RoundButton";
import ToastNotification from "../../components/ToastNotification";

const BrandProductReport = () => {
    const defaultDates = utility.getFirstAndLastDateOfMonth();

    const blankDataItem = { ProductButton: true, BrandButton: false, Channels: [], FromDate: defaultDates.FirstDate, ToDate: defaultDates.LastDate }
    const [dataItem, setDataItem] = useState(blankDataItem);
    const lang = useTranslation();
    const [brands, setBrands] = useState([]);
    const [products, setProducts] = useState([]);
    const [selectAllChannels, setSelectAllChannels] = useState(false);
    const [channels, setChannels] = useState([]);
    const [gridData, setGridData] = useState([]);
    const [loadingStatus, setLoadingStatus] = useState(lang.no_record_found_error_message);
    const [totalCount, setTotalCount] = useState(0);

    useEffect(() => {
        loadcombo();
    }, []);

    const loadcombo = async () => {
        let brandRes = await API.getDataLookup(ENTITYNAME.Brand, { sort: { Name: 1 } });
        setBrands([{ SID: 0, Name: "All" }, ...brandRes.data]);
        let productRes = await API.getDataLookup(ENTITYNAME.Product, { sort: { Name: 1 } });
        setProducts([{ SID: 0, Name: "All" }, ...productRes.data]);
        let channelRes = await API.getValidChannels();
        setChannels(channelRes.data);
    }
    const clearGrid = () => {
        setGridData([]);
        setTotalCount(0);
        setLoadingStatus(lang.no_record_found_error_message);
    };
    const onChange = async (e) => {
        clearGrid();
        if (e.target.name === "IsAllChannel") {
            const newValue = !selectAllChannels;
            setSelectAllChannels(newValue);
            setDataItem({ ...dataItem, Channels: newValue ? channels : [] });
        }
        else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }

    };
    const onChangeRadioButton = (e) => {
        clearGrid();
        if (e.target.name == "ProductButton") {
            setDataItem({ ...dataItem, ProductButton: !dataItem.ProductButton, BrandButton: false });
        } else {
            setDataItem({ ...dataItem, BrandButton: !dataItem.BrandButton, ProductButton: false });
        }
    }

    const isValid = () => {
        if (!utility.isValidDate(dataItem.FromDate)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_from_date_error_message });
            return false;
        }
        if (!utility.isValidDate(dataItem.ToDate)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_to_date_error_message });
            return false;
        }
        if (dataItem.ToDate < dataItem.FromDate) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_to_date_grater_then_from_date_error_message });
            return false;
        }
        if (!dataItem.Channels || dataItem.Channels.length === 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_channel_error_message });
            return false;
        }
        return true;
    };

    const loadData = async () => {
        if (!isValid()) return;
        setLoadingStatus(lang.data_loading_error_message)
        const fromdate = new Date(dataItem?.FromDate).setHours(0, 0, 0, 0);
        const todate = new Date(dataItem?.ToDate).setHours(23, 59, 59, 999);

        let payload = {
            startDate: Number(fromdate),
            endDate: Number(todate),
            channelsIds: dataItem?.Channels?.map(c => c._id),
            brandId: dataItem?.BrandButton ? dataItem?.Brand?._id : null,
            productId: dataItem?.ProductButton ? dataItem?.Product?._id : null,
            isExport: false
        }

        const res = await API.getBrandProductReport(payload);
        console.log(res);
        if (res.success) {
            if (res.data.length > 0) {
                setGridData(res.data);
                setTotalCount(res.data.length);
            }
            else {
                setGridData([]);
                setTotalCount(0);
                setLoadingStatus(lang.no_record_found_error_message);
            }
        }
        else {
            setGridData([]);
            setTotalCount(0);
            setLoadingStatus(lang.no_record_found_error_message);
        }

    }

    const downloadExcel = async () => {
        if (gridData.length === 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_record_found_error_message });
            return;
        }
        const fromdate = new Date(dataItem?.FromDate).setHours(0, 0, 0, 0);
        const todate = new Date(dataItem?.ToDate).setHours(23, 59, 59, 999);
        let payload = {
            startDate: Number(fromdate),
            endDate: Number(todate),
            channelsIds: dataItem?.Channels?.map(c => c._id),
            brandId: dataItem?.BrandButton ? dataItem?.Brand?._id : null,
            productId: dataItem?.ProductButton ? dataItem?.Product?._id : null,
            isExport: true
        }

        const res = await API.getBrandProductReport(payload);

        if (res.success) {
            window.open(FILEURL().BASEURL + 'downloadReport/' + res.data)
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.successfully_download_success_message });
        }
        else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    };

    return (<>
        <h1 className="page-title txt-color-bludeDark">
            <i
                className="fa fa-table marlr"
                style={{ fontSize: "20px", color: "GrayText" }}
            ></i>
            <span>{lang.brand_product_report_header}</span>
        </h1>
        <div className="col-12">
            <div className="row">
                <div className="flex-container wrap">
                    <div className="row mt-1 mb-1" style={{ marginLeft: '-11px' }}>
                        <div className="col">
                            <ActionButton name={lang.show_button_text} onClick={loadData} />
                            <RoundButton icon='download' onClick={() => downloadExcel()} style={{ marginLeft: '10px' }} title={lang.download_button_tooltip} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row mt-2">
                <div className="col-2">
                    <div className="form-group">
                        <label htmlFor="TabView">{lang.from_date_label} *</label>
                        <input className="form-control form-control-sm" type={'date'} name={"FromDate"} value={dataItem.FromDate} onChange={onChange} max={dataItem.ToDate} />
                    </div>
                </div>
                <div className="col-2">
                    <div className="form-group">
                        <label htmlFor="TabView">{lang.to_date_label} *</label>
                        <input className="form-control form-control-sm" type={'date'} name={"ToDate"} value={dataItem.ToDate} onChange={onChange} min={dataItem.FromDate} />
                    </div>
                </div>
                <div className="col-3">
                    <div className="col form-group">
                        <div className="d-flex justify-content-between align-items-center mb-1">
                            <label className="mb-0 fw-semibold">
                                {lang.channel_label} *
                            </label>

                            <div className="d-flex align-items-center">
                                <span className="me-1">{lang.select_all_label}</span>
                                <input
                                    type="checkbox"
                                    name="IsAllChannel"
                                    className="ml-1"
                                    value={selectAllChannels}
                                    checked={selectAllChannels}
                                    onChange={(e) => onChange(e)}
                                />
                            </div>
                        </div>
                        <div className="d-flex align-items-center">
                            <div style={{ flex: 1 }}>
                                <MultiSelect
                                    data={channels}
                                    name="Channels"
                                    textField="FullChannelName"
                                    dataItemKey="_id"
                                    value={dataItem.Channels}
                                    onChange={onChange}
                                    style={{ maxHeight: "65px" }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-1 mt-4" style={{ padding: "0" }}>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <RadioButton
                        style={{ marginLeft: "5px" }}
                        name="BrandButton"
                        value={dataItem.BrandButton}
                        checked={dataItem.BrandButton}
                        label=""
                        onClick={onChangeRadioButton}
                    />&nbsp;&nbsp;&nbsp;&nbsp;
                    <label htmlFor="TabView">{lang.brand_label}</label>
                </div>
                <div className="col-1 mt-4" style={{ padding: "0" }}>
                    <RadioButton
                        name="ProductButton"
                        checked={dataItem.ProductButton}
                        value={dataItem.ProductButton}
                        label=""
                        onClick={onChangeRadioButton}
                    />&nbsp;&nbsp;&nbsp;&nbsp;
                    <label htmlFor="TabView">{lang.product_label}</label>
                </div>
                {dataItem.ProductButton ?
                    <div className="col-3">
                        <label htmlFor="TabView">{lang.product_label}</label>
                        <DropDownList
                            style={{ backgroundColor: "white" }}
                            data={products}
                            name="Product"
                            defaultValue={products[0]}
                            textField="Name"
                            dataItemKey="_id"
                            value={dataItem.Product}
                            onChange={onChange}
                            validator={(value) => value ? "" : "Please Select Product"}
                        />
                    </div> :
                    <div className="col-3">
                        <label htmlFor="TabView">{lang.brand_label}</label>
                        <DropDownList
                            style={{ backgroundColor: "white" }}
                            data={brands}
                            name="Brand"
                            defaultValue={brands[0]}
                            textField="Name"
                            dataItemKey="_id"
                            value={dataItem.Brand}
                            onChange={onChange}
                            validator={(value) => value ? "" : "Please Select Brand"}
                        />
                    </div>
                }
            </div>
            <div className="row">
                <div className="col-12 d-flex justify-content-end">
                    <span>Total Count: {totalCount}</span>
                </div>
            </div>
            <div className="row mt-2">
                <div className="col-12">
                    <Grid data={gridData} style={{ height: '60vh' }} resizable={true}>
                        <GridNoRecords>{loadingStatus}</GridNoRecords>
                        <Column field="Channel" title={lang.channel_column} width="150px" />
                        <Column field="TelecastDate" title={lang.telecast_date_column} width="140px" />
                        <Column field="TelecastDay" title={lang.telecast_day_column} width="140px" />
                        <Column field="Client" title={lang.client_column} width="180px" />
                        <Column field="Agency" title={lang.agency_column} width="180px" />
                        <Column field="SalesUnit" title={lang.sales_unit_column} width="140px" />
                        <Column field="AiredTime" title={lang.aired_time_column} width="120px" />
                        <Column field="Rate10Sec" title={lang.rate10sec_column} width="120px" />
                        <Column field="SpotRate" title={lang.spot_rate_column} width="120px" />
                        <Column field="CommercialName" title={lang.commercial_column} width="220px" />
                        <Column field="CommercialID" title={lang.commercial_id_column} width="160px" />
                        <Column field="Duration" title={lang.duration_column} width="120px" />
                        <Column field="BrandName" title={lang.brand_column} width="180px" />
                        <Column field="ProductName" title={lang.product_column} width="180px" />
                        <Column field="ProgramName" title={lang.program_column} width="200px" />
                        <Column field="EpisodeCode" title={lang.episode_code_column} width="140px" />
                        <Column field="CampaignType" title={lang.Campaign_type_column} width="160px" />
                        <Column field="InvoiceNo" title={lang.invoice_no_column} width="140px" />
                        <Column field="CampaignID" title={lang.campaign_id_column} width="140px" />
                        <Column field="Status" title={lang.status_column} width="140px" />
                        <Column field="Campaign" title={lang.campaign_column} width="200px" />
                        <Column field="Region" title={lang.region_column} width="160px" />
                        <Column field="SalesExecutive" title={lang.sales_executive_label} width="180px" />
                        <Column field="AgencyGST" title={lang.agency_gst_column} width="160px" />
                        <Column field="ClientGST" title={lang.client_gst_column} width="160px" />
                        <Column field="AgencyPOS" title={lang.agency_pos_column} width="180px" />
                        <Column field="ClientPOS" title={lang.client_pos_column} width="180px" />
                        <Column field="ReferenceNumber" title={lang.reference_no_column} width="180px" />
                    </Grid>
                </div>
            </div>
        </div>
    </>)
}
export default BrandProductReport;